import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const widgetConfigRequest = createAction(types.WIDGET_CONFIG_REQUEST);
export const widgetConfigSuccess = createAction(types.WIDGET_CONFIG_SUCCESS);
export const widgetConfigFailure = createAction(types.WIDGET_CONFIG_FAILURE);

export const widgetConfigPreviewRequest = createAction(
  types.WIDGET_CONFIG_PREVIEW_REQUEST,
);
export const widgetConfigPreviewSuccess = createAction(
  types.WIDGET_CONFIG_PREVIEW_SUCCESS,
);
export const widgetConfigPreviewFailure = createAction(
  types.WIDGET_CONFIG_PREVIEW_FAILURE,
);

export const setWidgetConfig = widgetConfigSuccess;

export const updateWidgetConfigRequest = createAction(
  types.UPDATE_WIDGET_CONFIG_REQUEST,
);
export const updateWidgetConfigSuccess = createAction(
  types.UPDATE_WIDGET_CONFIG_SUCCESS,
);
export const updateWidgetConfigFailure = createAction(
  types.UPDATE_WIDGET_CONFIG_FAILURE,
);

const widgetsActions = {
  widgetConfigRequest,
  widgetConfigSuccess,
  widgetConfigFailure,
  widgetConfigPreviewRequest,
  widgetConfigPreviewSuccess,
  widgetConfigPreviewFailure,
  setWidgetConfig,
  updateWidgetConfigRequest,
  updateWidgetConfigSuccess,
  updateWidgetConfigFailure,
};

export default widgetsActions;
